import { useSelector } from "react-redux"
import { WinnersPopup } from "./WinnersPopup"
import { closeWinnersPopup } from "../../redux/actions"

export const WheelWinnersPopup = () => {
  const id = useSelector(state => state.game.gameWheel.settings.id)
  const allWinners = useSelector(state => state.game.allWinners)
  const pagination = useSelector(state => state.game.pagination)
  const winners = useSelector(state => state.game.gameWheel.winners)
  const winnersPopup = useSelector(state => state.game.winnersPopup)
  const lang = useSelector(state => state.app.currentLang)

  if (!winnersPopup) return (null)

  return(
    <WinnersPopup 
      id={id}
      winners={winners}
      allWinners={allWinners}
      pagination={pagination}
      game='wheel'
      close={closeWinnersPopup}
      title={lang.games3}
    />
  )
}